import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

const createHistory = (navigate, location) => ({
	length: window.history.length,
	location,
	push: (to, state) => navigate(to, { state }),
	replace: (to, state) => navigate(to, { replace: true, state }),
	go: (delta) => navigate(delta),
	goBack: () => navigate(-1),
	goForward: () => navigate(1)
})

export const withRouter = (Component) => {
	const ComponentWithRouter = (props) => {
		const location = useLocation()
		const navigate = useNavigate()
		const params = useParams()
		const history = createHistory(navigate, location)

		return <Component
			{...props}
			history={history}
			location={location}
			match={{ params }}
		/>
	}

	ComponentWithRouter.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`
	return ComponentWithRouter
}
